import * as React from 'react';
import GetInTouchForm from '../GetInTouchForm/getIntouch';

const UnderAttack = ({ id, title}) => {

    return (
        <GetInTouchForm id={id}>
            <form action="https://submit-form.com/4COHOYtk" id="contactForm" >
                <div className="form-group">
                    <label htmlFor="name">
                        Name
                    </label>
                    <input type="text" id="name" name="name" className="form-control" placeholder="Your Name" required />
                </div>
                <div className="row">
                    <div className="col m6 s12">
                        <div className="form-group">
                            <label htmlFor="email">
                                Work Email
                            </label>
                            <input type="email" id="email" name="email" className="form-control" placeholder="name@company.com" required />
                        </div>
                    </div>
                    <div className="col m6 s12">
                        <div className="form-group">
                            <label htmlFor="phone">
                                Phone Number
                            </label>
                            <input type="tel" pattern="\+[0-9]{0,14}$" id="phone" name="phone" className="form-control" placeholder="Phone Number" required />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12">
                        <label htmlFor="description" className="large">
                            Description of attack
                        </label>
                        <textarea name="description" id="description" cols="30" rows="10"></textarea>
                    </div>
                </div>
                <input id="name" type="hidden" className="hidden" name="source" value={title} />
                <button type="submit" value="Submit" name="submit" className="btn submit-btn">Let's Mitigate!</button>
            </form>
        </GetInTouchForm>
    );
}

export default UnderAttack;